import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d59628e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "section border-b" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Configuraciones generales", -1))
const _hoisted_5 = { class: "section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Notificaciones", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchablePropertyCard = _resolveComponent("SwitchablePropertyCard")!

  return (_ctx.notificationSettings)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_SwitchablePropertyCard, {
              actived: _ctx.notificationSettings.receiveMails,
              "onUpdate:actived": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationSettings.receiveMails) = $event)),
              title: "Recibir Notificaciones por correo",
              description: "Habilita esta opción para recibir una copia de las notificaciones que recibes en el sistema de Rentas Dhelos en tu correo personal. "
            }, null, 8, ["actived"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_SwitchablePropertyCard, {
              actived: _ctx.reportOnRequestStatusChange,
              "onUpdate:actived": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reportOnRequestStatusChange) = $event)),
              title: "Actualización de estado de solicitud de movimiento",
              description: "Habilita esta opción para recibir una notificación cuando tus solicitudes de movimiento sean aceptadas o rechazadas por los administradores de Rentas Dhelos."
            }, null, 8, ["actived"]),
            _createVNode(_component_SwitchablePropertyCard, {
              actived: _ctx.reportOnSharesMovement,
              "onUpdate:actived": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reportOnSharesMovement) = $event)),
              title: "Movimiento de acciones",
              description: "Habilita esta opción para recibir una notificación cuando se cree un nuevo movimiento de acciones."
            }, null, 8, ["actived"]),
            _createVNode(_component_SwitchablePropertyCard, {
              actived: _ctx.reportOnDividendPayment,
              "onUpdate:actived": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reportOnDividendPayment) = $event)),
              title: "Pago de dividendos",
              description: "Habilita esta opción para recibir una notificación cuando se realice un nuevo pago de dividendo."
            }, null, 8, ["actived"])
          ]),
          _createElementVNode("button", {
            class: "success w-36 btn ml-auto",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitConfig && _ctx.submitConfig(...args)))
          }, " Guardar ")
        ])
      ]))
    : _createCommentVNode("", true)
}